export const roles = {
  USER_ADMIN: "User Admin",
  OPERATOR: "Operator",
  INFRA_ADMIN: "Infra Admin",
  SERVICE: "Service"
};
